import styled, { css } from 'styled-components';

export const GridContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const ButtonMediaUploadWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.m};
  padding-left: ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.seasalt};
`;

export const AssessmentStandarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  width: 100%;
`;

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 100%;
  margin-top: 85px;
`;

export const ImageInputContainer = styled.input`
  display: none;
`;

export const TabContainer = styled.ul`
  margin: 0 ${({ theme }) => theme.spacing.m};
`;

export const SubTabContainer = styled.li`
  margin: 0 ${({ theme }) => theme.spacing.m};
`;

export const StyledStandardPerformaceSelector = styled.div`
  margin: 0 ${({ theme }) => theme.spacing.m};
`;

export const TitleContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.xm}`}
    ${({ theme }) => theme.spacing.m} ${({ theme }) => `${theme.spacing.m}`}
    ${({ theme }) => theme.spacing.m};
`;

export const StandardCard = styled.div`
  border-bottom: 1px #f1f1f1 solid;
  padding-bottom: ${({ theme }) => theme.spacing.m};
  margin: ${({ theme }) => theme.spacing.m};
  margin-top: 0;
  display: grid;
`;

export const CommentsContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.l}`}
    ${({ theme }) => theme.spacing.m};
`;

export const ButtonBlockWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
`;

export const ButtonWithIcon = styled.button(
  ({ theme, borderColor = 'platinum', backgroundColor = 'white' }) => css`
    border: 1px solid ${theme.colors[borderColor] || backgroundColor} !important;
    border-radius: ${theme.radius.xs};
    background-color: ${theme.colors[backgroundColor] ||
    backgroundColor} !important;
    height: ${theme.spacing.xl};
    width: ${theme.spacing.xl};
    display: flex;
    justify-content: center;
    align-items: center;
  `
);
